import { prepareCompanyData } from './../concession-registration.utility';
import { ConcessionRegistrationService } from './../concession-registration.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApplicationResponseData, DateFormat, TechnicianApplicationData } from '../../domains/common.domain';
import { Companies } from '../../model/companies';
import { LocalStorageService } from '../../services/local-storage.service';
import { FileData, FormatterData, UserStatus } from '../../constants/app.constants';
import { CommunicationService } from '../../services/communication.service';
import { SelectItem } from 'primeng';
import { FileService } from '../../services/file.service';
import { DocumentData } from '../../employee-overview/employee-overview.domain';
import { LookupOptionsData } from '../../jurisdiction/jurisdiction.domain';
import { AllDropdownKeys } from '../../jurisdiction/jurisdiction.constants';
import { CommonService } from '../../services/common.service';
import { EnvironmentService } from '../../services/environment.service';
import {
  MandatoryDocumentsPerCommodity,
  OptionalDocumentsByCommodity,
  OptionalDocumentsByQualification,
} from 'src/app/interface/config.interface';
import { RegistrationService } from 'src/app/registration/registration.service';
import { ConcessionManagementDataValidationForm } from '../concession-registration.models';
import { ConcessionDataValidationFormUpdateModel } from './data-concession-validation/data-concession-validation.component';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { filter, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ValidationsService } from 'src/app/services/validations.service';
import { ErrorService } from 'src/app/services/error/error.service';

export type DataConcessionScenario = 'Manual' | 'Mixed';

@Component({
  selector: 'app-concession-basic-profile',
  templateUrl: './concession-basic-profile.component.html',
  styleUrls: ['./concession-basic-profile.component.scss'],
})
export class ConcessionBasicProfileComponent extends DestroyableComponent implements OnInit, OnDestroy {
  dateFormat: DateFormat = FormatterData.date;
  companyDataFG: FormGroup;
  technicianDataFG: FormGroup;
  checkDataFG: FormGroup;
  educationInformationDataFG: FormGroup;
  technicianApplication: TechnicianApplicationData;
  documents: any;
  titleKey: string = AllDropdownKeys.Title;
  allTitles: LookupOptionsData[] = this.commonService.getDropdownData(AllDropdownKeys.Title);
  userStatus: any = UserStatus;
  companyExist: boolean = false;

  technicianApplicationId: string;
  companyId: string;
  technicianId: string;
  submitted: boolean = false;
  commodities = ['power', 'gas', 'water', 'heating'];
  options: SelectItem[];
  isLoading: boolean;
  allDocumentsResultingOfEmptyChecks: boolean;
  optionalDocumentsTypes: Set<string> = new Set<string>();
  takeMandatoryDocumentsTypes: Set<string> = new Set<string>();
  specialistMandatoryDocumentsTypes: Set<string> = new Set<string>();
  mandatoryDocumentsPerCommodity: MandatoryDocumentsPerCommodity = this.environmentService.mandatoryDocumentsPerCommodity;
  optionalDocumentsByCommodity: OptionalDocumentsByCommodity[] = this.environmentService.optionalDocumentsByCommodity;
  optionalDocumentsByQualification: OptionalDocumentsByQualification[] = this.environmentService.optionalDocumentsByQualification;
  showBaseDataEmail: boolean = this.environmentService.showBaseDataEmail;
  showTechnicianDataEmail: boolean = this.environmentService.showTechnicianDataEmail;
  showMastersExaminationOn: boolean = this.environmentService.showMastersExaminationOn;
  showHeatingWeldingCertificateConfirmation: boolean = this.environmentService.showHeatingWeldingCertificateConfirmation;
  showSafetyTechnologyExemptionDocument: boolean = this.environmentService.showSafetyTechnologyExemptionDocument;
  showSafetyTechnologyAuthorizationDocument: boolean = this.environmentService.showSafetyTechnologyAuthorizationDocument;

  dataConcessionScenario: DataConcessionScenario = this.environmentService.dataForConcessionValidationScenario;
  concessionManagementDataValidationForm: ConcessionManagementDataValidationForm;
  isDataConcessionValidationValid: boolean = false;
  concessionValidationInitial = {};

  constructor(
    private registrationService: RegistrationService,
    private communicationService: CommunicationService,
    private localStorageService: LocalStorageService,
    private concessionRegistrationService: ConcessionRegistrationService,
    private fileService: FileService,
    private ref: ChangeDetectorRef,
    private commonService: CommonService,
    private environmentService: EnvironmentService,
    private errorService: ErrorService
  ) {
    super();
  }

  ngOnInit(): void {
    this.companyDataFG = this.registrationService.companyDataFG;
    this.technicianDataFG = this.registrationService.technicianDataFG;
    this.technicianDataFG.controls['qualification_type'].disable(); // not relevant for this page
    this.checkDataFG = this.registrationService.checkDataFG;
    this.educationInformationDataFG = this.registrationService.educationInformationDataFG;

    this.isLoading = true;

    this.updateValidation();
    this.getTechnicianApplication();

    this.preventLeak(this.concessionRegistrationService.concessionDataValidationFormUpdated$).subscribe(
      (data: ConcessionDataValidationFormUpdateModel) => {
        this.concessionManagementDataValidationForm = data.formValue;

        if (!data.preventUpdate) {
          this.updateTechnicianApplication({ qualificationType: data.formValue.occupation });
        }
      }
    );
  }

  getTechnicianApplication(): void {
    const technicianId: string = this.localStorageService.getItem('technician_id');
    this.preventLeak(this.registrationService.getTechnicianApplication(technicianId, 'technician_id')).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response && response.technician_application && response.technician_application.length) {
          let birthday = response.technician_application[0].technician && response.technician_application[0].technician[0]?.birthday;
          if (birthday) {
            birthday = this.commonService.parseDateForUI(birthday);
            response.technician_application[0].technician[0].birthday = birthday;
          }
          this.setFormValues(response);

          this.concessionValidationInitial = {
            bdewTechnicianId: response.technician_application[0]?.technician[0]?.bdew_id,
            occupation: response.technician_application[0]?.technician[0]?.qualification_type,
            hasWeldingLicense: response.technician_application[0]?.technician[0]?.welding_license === '1',
            isRegisterForDistrictHeating: response.technician_application[0]?.technician[0]?.concession_district_heating === '1',
            role: response.technician_application[0]?.technician[0]?.role,
            registeredCommodities: {
              power: response.technician_application[0]?.technician[0]?.concession_power === '1',
              gas: response.technician_application[0]?.technician[0]?.concession_gas === '1',
              water: response.technician_application[0]?.technician[0]?.concession_water === '1',
              heating: response.technician_application[0]?.technician[0]?.concession_district_heating === '1',
            },
          };
        } else {
          this.technicianDataFG.reset();
          this.saveTechnicianApplication(technicianId);
        }
        this.ref.detectChanges();
      },
      error => {
        this.isLoading = false;
        if (error.status !== 0) {
          this.technicianDataFG.reset();
          this.saveTechnicianApplication(technicianId);
        }
      }
    );
  }

  saveTechnicianApplication(technicianId: string): void {
    const saveData = this.setTechnicianApplicationForm();
    this.preventLeak(this.registrationService.saveNewTechnicianApplication(saveData, technicianId))
      .pipe(
        filter((response: any) => response && response.created && response.created.length),
        switchMap((response: any): Observable<any> => {
          this.technicianApplicationId = response.created[0].ta_id;
          return this.preventLeak(this.registrationService.getTechnicianApplication(this.technicianApplicationId, 'ta_id'));
        })
      )
      .subscribe((taResponse: any) => {
        this.setFormValues(taResponse);
      });
  }

  getCompanyDetails(): void {
    const taxId = this.companyDataFG.get('tax_id').value;
    if (taxId) {
      this.preventLeak(this.communicationService.getCompany(taxId)).subscribe((companies: Companies) => {
        if (companies.company && companies.company.length) {
          const companyData = prepareCompanyData(companies.company[0]);
          this.companyId = companyData.company_id;
          this.companyDataFG.patchValue(companyData);
          this.updateTechnicianApplication({ companyId: companyData.company_id });
          this.companyExist = true;
        } else {
          this.companyExist = false;
          this.companyDataFG.get('tax_id').setValue(taxId);
          this.saveNewCompany();
        }
      });
    } else {
      this.companyId = '';
      this.companyExist = false;
      this.companyDataFG.reset();
      const updateData = {
        company: [],
      };
      this.preventLeak(this.registrationService.updateTechnicianApplication(updateData, this.technicianApplicationId)).subscribe(() => {});
    }
  }

  saveNewCompany(data?: { companyId: string }): void {
    this.updateTechnicianApplication({ companyId: data?.companyId ?? this.companyId });
  }

  updateTechnicianApplication(data: { companyId?: string; qualificationType?: string }): void {
    const updateData = {
      technician_application: [
        {
          company_id: data.companyId,
          qualification_type: data.qualificationType,
        },
      ],
    };

    if (this.technicianApplicationId) {
      this.preventLeak(this.registrationService.updateTechnicianApplication(updateData, this.technicianApplicationId)).subscribe(() => {
        this.getTechnicianApplication();
      });
    }
  }

  updateCompany(): void {
    if (this.companyId) {
      const company = this.companyDataFG.value;
      company.headoffice = company.headsubsidiary === 'hauptbetrieb' ? 'true' : 'false';
      company.subsidiary = company.headsubsidiary === 'nebenbetrieb' ? 'true' : 'false';
      company.main_businesses_part_time = company.headsubsidiary === 'main_businesses_part_time' ? 'true' : 'false';
      company.in_auxiliary_operation = company.headsubsidiary === 'in_auxiliary_operation' ? 'true' : 'false';
      company.company_id = this.companyId;
      const updateData = {
        company: [company],
      };
      this.preventLeak(this.registrationService.updateCompany(updateData, this.companyId)).subscribe(() => {});
    } else {
      this.saveNewCompany();
    }
  }

  saveForm(): void {
    if (this.companyDataFG.valid && this.technicianDataFG.valid && this.educationInformationDataFG) {
      const updateData = {
        technician_application: [
          {
            status: this.userStatus.SUBMITTED,
          },
        ],
      };
      this.deleteFiles();
      const technicianId: string = this.localStorageService.getItem('technician_id');

      if (this.dataConcessionScenario === 'Mixed' && this.concessionManagementDataValidationForm.hasBdewId) {
        this.isLoading = true;
        this.preventLeak(
          this.registrationService.updateTechnicianApplicationWithConcessionValidation({
            technicianId: +this.technicianId,
            shouldAutoUpdatePartially: !!this.concessionManagementDataValidationForm.isRegisterForDistrictHeating,
            concessionRegistrationId: this.concessionManagementDataValidationForm.bdewTechnicianId,
            technicianApplicationId: +this.technicianApplicationId,
            technicianFirstName: this.technicianDataFG.controls.first_name.value,
            technicianLastName: this.technicianDataFG.controls.last_name.value,
          })
        )
          .pipe(
            switchMap(() => {
              this.submitted = true;
              return this.preventLeak(this.registrationService.getTechnicianApplication(technicianId, 'technician_id'));
            })
          )
          .subscribe(
            () => {
              this.isLoading = false;
              this.getTechnicianApplication();
            },
            error => {
              this.updateDataConcessionValidationStatus(false);
              this.isLoading = false;
              this.errorService.throwErrorIfFailure(
                {
                  result: 'error',
                  message: error.error.message,
                },
                true
              );
            },
            () => (this.isLoading = false)
          );
      } else {
        this.isLoading = true;
        this.preventLeak(this.registrationService.updateTechnicianApplication(updateData, this.technicianApplicationId))
          .pipe(
            switchMap(() => {
              this.submitted = true;
              return this.preventLeak(this.registrationService.getTechnicianApplication(technicianId, 'technician_id'));
            })
          )
          .subscribe(
            (response: ApplicationResponseData) => {
              this.isLoading = false;
              this.technicianApplication = response.technician_application[0];
              this.parseDocumentValues();
            },
            _ => {},
            () => (this.isLoading = false)
          );
      }
    } else {
      this.validateFormFields(this.companyDataFG);
      this.validateFormFields(this.technicianDataFG);
    }
  }

  validateFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateFormFields(control);
      }
    });
  }

  private setTechnicianApplicationForm(): any {
    const technician = this.technicianDataFG.value;
    technician.role = this.userStatus.STANDARDTECHNICIAN;
    this.addEducationInformationData(technician);
    return {
      technician_application: [
        {
          technician: [technician],
        },
      ],
    };
  }

  fileEvent(): void {
    // this.getTechnicianApplication();
    const technicianId: string = this.localStorageService.getItem('technician_id');
    this.preventLeak(this.registrationService.getTechnicianApplication(technicianId, 'technician_id')).subscribe((response: any) => {
      this.isLoading = false;
      this.technicianApplication.document = response.technician_application[0].document;
      this.parseDocumentValues();
    });
  }

  private setFormValues(response: any): void {
    if (response && response.technician_application && response.technician_application.length) {
      this.technicianApplication = response.technician_application[0];
      if (
        this.technicianApplication &&
        this.technicianApplication.status &&
        (this.technicianApplication.status === UserStatus.SUBMITTED ||
          this.technicianApplication.status === UserStatus.GRANTED ||
          this.technicianApplication.status === UserStatus.ISSUED ||
          this.technicianApplication.status === UserStatus.PARTIALLY_ISSUED)
      ) {
        this.submitted = true;
      } else {
        this.technicianApplicationId = this.technicianApplication.ta_id;
        this.companyId = this.technicianApplication.company_id;
        this.technicianId = this.technicianApplication.technician_id;

        this.parseDocumentValues();

        if (this.technicianApplication.technician && this.technicianApplication.technician.length) {
          this.technicianApplication.technician[0].qualification_type = this.technicianApplication.qualification_type;
          this.technicianDataFG.patchValue(this.technicianApplication.technician[0]);
          const checkData = {
            power: this.technicianApplication.technician[0].concession_power === '1',
            gas: this.technicianApplication.technician[0].concession_gas === '1',
            water: this.technicianApplication.technician[0].concession_water === '1',
            heating: this.technicianApplication.technician[0].concession_district_heating === '1',
            license: this.technicianApplication.technician[0].welding_license === '1' ? 'withLicense' : 'withoutLicense',
          };
          this.checkDataFG.patchValue(checkData);

          const educationInformationData = this.technicianApplication.technician[0]?.education_information;
          this.setEducationInformation(educationInformationData);
        } else {
          this.technicianDataFG.reset();
          this.checkDataFG.reset();
          this.educationInformationDataFG.reset();
        }
        this.validateFormFields(this.technicianDataFG);
        this.validateFormFields(this.checkDataFG);
        if (this.technicianApplication.company && this.technicianApplication.company.length) {
          let companyData = this.technicianApplication.company[0];
          companyData = prepareCompanyData(companyData);
          this.companyDataFG.patchValue(companyData);
        } else {
          this.companyDataFG.reset();
        }
        this.validateFormFields(this.companyDataFG);
      }
    }
  }

  private parseDocumentValues(): void {
    if (this.technicianApplication && this.technicianApplication.document) {
      this.documents = this.technicianApplication.document;
    }
  }

  getLicenseEnabled(): boolean {
    const checkData = this.checkDataFG.value;
    if (checkData && checkData.license && checkData.license === 'withLicense') {
      return this.getButtonEnabled('welding_certificate_confirmation');
    }
    return false;
  }

  getDropdownEnabled(): boolean {
    const technicianData = this.technicianDataFG.value;
    if (technicianData.qualification_type === 'Meister') {
      return this.getButtonEnabled(FileData.PROOFOFQUALIFICATION);
    } else if (technicianData.qualification_type === 'Ingenieur' || technicianData.qualification_type === 'Meister In anderem Handwerk') {
      return this.getButtonEnabled(FileData.PROOFOFQUALIFICATION) || this.getButtonEnabled(FileData.PROOFOFEXPERTISE);
    } else if (technicianData.qualification_type === 'Altgeselle') {
      return (
        this.getButtonEnabled(FileData.PROOFOFQUALIFICATION) ||
        this.getButtonEnabled(FileData.PROOFOFEXPERTISE) ||
        this.getButtonEnabled(FileData.PROOFOFCONTRACT)
      );
    } else if (technicianData.qualification_type === 'Ausnahmebewilligung') {
      return this.getButtonEnabled(FileData.PROOFOFEXPERTISE) || this.getButtonEnabled(FileData.PROOFOFCONTRACT);
    }
    return false;
  }

  getButtonEnabled(type: string): boolean {
    const isEnabled: boolean = this.fileService.checkForAvailableDocuments(this.documents, type);
    return isEnabled !== true;
  }

  enabledRadioButtons(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.heating;
  }

  enabledFileUpload(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.license && checkData.license === 'withLicense';
  }

  enableHeatingWeldingCertificateConfirmation(): boolean {
    const checkData = this.checkDataFG.value;
    return checkData && checkData.heating && this.showHeatingWeldingCertificateConfirmation;
  }

  getFileEnabled(fileType: string): boolean {
    const technicianData = this.technicianDataFG.value;
    if (!technicianData.qualification_type) {
      return true;
    }

    const fileTypeQualificationsMap: { [key: string]: string[] } = {
      proof_of_qualification: ['Meister', 'Ingenieur', 'Meister In anderem Handwerk', 'Altgeselle'],
      proof_of_expertise: ['Ausnahmebewilligung', 'Ingenieur', 'Meister In anderem Handwerk', 'Altgeselle'],
      proof_of_contract: ['Ausnahmebewilligung', 'Altgeselle'],
    };

    const fileTypeQualifications = fileTypeQualificationsMap[fileType] || [];

    return !!fileTypeQualifications.find(q => technicianData.qualification_type === q);
  }

  deleteFiles(): void {
    const technicianData = this.technicianDataFG.value;
    const checkData = this.checkDataFG.value;
    if (technicianData.qualification_type === 'Meister') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFEXPERTISE);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (
      technicianData.qualification_type === 'Meister' ||
      technicianData.qualification_type === 'Ingenieur' ||
      technicianData.qualification_type === 'Meister In anderem Handwerk'
    ) {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFCONTRACT);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (technicianData.qualification_type === 'Ausnahmebewilligung') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.PROOFOFQUALIFICATION);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
    if (!checkData.heating || checkData.license === null || checkData.license === '' || checkData.license === 'withoutLicense') {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, FileData.WELDINGCERTIFICATECONFIRMATION);
      if (document !== null && document !== undefined && document.length) {
        this.removeFile(document[0].document_id);
      }
    }
  }

  removeFile(documentId: string): void {
    this.preventLeak(this.fileService.removeFile(documentId)).subscribe(() => {
      const index = this.fileService.checkIndex(this.documents, documentId);
      if (index !== -1) {
        this.documents.splice(index, 1);
      }
      this.ref.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.registrationService.technicianDataFG.reset();
    this.registrationService.companyDataFG.reset();
    this.registrationService.educationInformationDataFG.reset();
  }

  allTakeMandatoryDocumentsUploaded() {
    return (
      !this.concessionManagementDataValidationForm.isRegisterForDistrictHeating ||
      ([...this.takeMandatoryDocumentsTypes].every(mandatoryDoc => this.documents.some(doc => doc.name === mandatoryDoc)) &&
        [...this.specialistMandatoryDocumentsTypes].every(mandatoryDoc => this.documents.some(doc => doc.name === mandatoryDoc)))
    );
  }

  updateValidation() {
    if (this.showBaseDataEmail) {
      this.companyDataFG.controls.email.setValidators([Validators.required, ValidationsService.emailValidator()]);
      this.companyDataFG.controls.email.updateValueAndValidity();
    }

    if (this.showTechnicianDataEmail) {
      this.technicianDataFG.controls.email.setValidators([Validators.required, ValidationsService.emailValidator()]);
      this.technicianDataFG.controls.email.updateValueAndValidity();
    }

    if (this.showMastersExaminationOn) {
      this.technicianDataFG.controls.qualification_issued_on.setValidators([Validators.required]);
      this.technicianDataFG.controls.qualification_issued_on.updateValueAndValidity();
    }
  }

  updateDataConcessionValidationStatus(isValid: boolean) {
    this.isDataConcessionValidationValid = isValid;
    this.ref.detectChanges();
  }

  isDisableSaveForm(): boolean {
    return (
      !this.companyDataFG.valid ||
      !this.technicianDataFG.valid ||
      (this.concessionManagementDataValidationForm.isRegisterForDistrictHeating && this.getLicenseEnabled()) ||
      this.getDropdownEnabled() ||
      !this.allTakeMandatoryDocumentsUploaded() ||
      !this.educationInformationDataFG.valid ||
      !this.isDataConcessionValidationValid
    );
  }

  private addEducationInformationData(technician: any): void {
    const educationInformationData = this.educationInformationDataFG.value;
    if (educationInformationData) {
      technician.education_information = educationInformationData;
    }
  }

  private setEducationInformation(educationInformationData: any) {
    if (educationInformationData) {
      const educationInformation = {
        journeyman_training_as: educationInformationData.journeyman_training_as,
        diploma_technician_specialization: educationInformationData.diploma_technician_specialization,
        university_or_technical_college_degree_specialty: educationInformationData.university_or_technical_college_degree_specialty,
        journeyman_training_on: educationInformationData.journeyman_training_on,
        diploma_technician_on: educationInformationData.diploma_technician_on,
        university_or_technical_college_degree_on: educationInformationData.university_or_technical_college_degree_on,
      };
      this.educationInformationDataFG.patchValue(educationInformation);
    }
  }
}
